import { __awaiter, __generator } from "tslib";
import _useLruCache from './composable/useLruCache';
export var useLruCache = _useLruCache;
export default function (_a) {
    var options = _a.options, routes = _a.routes;
    var containers = _useLruCache();
    containers.setDefaultOptions(options);
    var cache = containers.get('fpc');
    return {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        invoke: function (_a) {
            var _b;
            var route = _a.route, context = _a.context, render = _a.render, getTags = _a.getTags;
            return __awaiter(this, void 0, void 0, function () {
                var maxAge, shouldFullPageCache, key, cachedResponse, content;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            maxAge = null;
                            shouldFullPageCache = route in routes && ((_b = context.req) === null || _b === void 0 ? void 0 : _b.$vsfCache);
                            key = "page:".concat(route);
                            cachedResponse = shouldFullPageCache ? cache.get(key) : null;
                            if (cachedResponse) {
                                return [2 /*return*/, cachedResponse];
                            }
                            return [4 /*yield*/, render()];
                        case 1:
                            content = _c.sent();
                            if (shouldFullPageCache && getTags().length) {
                                return [2 /*return*/, content];
                            }
                            cache.set(key, content, maxAge);
                            return [2 /*return*/, content];
                    }
                });
            });
        },
        // eslint-disable-next-line require-await,@typescript-eslint/no-unused-vars
        invalidate: function (_a) {
            var request = _a.request, response = _a.response, tags = _a.tags;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    if (tags.includes('*')) {
                        cache.reset();
                    }
                    else {
                        // invalidate provided tags OR use from request some other approach to invalidate key(s)
                        // TODO await client.invalidate(tags)
                    }
                    return [2 /*return*/];
                });
            });
        }
    };
}
//# sourceMappingURL=index.js.map